import { createStore, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
// import { logger } from "redux-logger";
import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "./root.reducer";

const configureStore = (persistedState) => {
  var middlewares = [thunkMiddleware];

  if (process.env.NODE_ENV !== "production") {
    middlewares = [...middlewares];
  }

  const store = createStore(
    rootReducer,
    persistedState,
    composeWithDevTools(applyMiddleware(...middlewares))
  );

  return store;
};

export default configureStore;
